
jQuery('a[href="/collections/mens-tops"]').attr('aria-label','mens tops');
jQuery('form-iframe-13131').attr('title','Contact Form');
 jQuery(".card__content .card__information a").removeAttr("aria-labelledby"); 
  jQuery(".fm-search-box").removeAttr("id");
jQuery(".fm-search-box").attr("aria-label", "search");
  jQuery(".filter-group h4").attr("aria-level", "2");
  jQuery(".global-media-settings button, .global-media-settings").removeAttr("aria-describedby");      
   
  $(".filshow").click(function(){
    $(this).attr('aria-expanded', function(i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  });

  $(".shopify-planet-banner-v2-car-illustration, .shopify-planet-banner-v2-margin-b, br").attr("aria-hidden", "true");
  $(".gmap, .abthparty").attr("target","_blank");
  $(".shopify-policy__body h4").attr("aria-level", "2");
  $(".copyright__content a[target='_blank']").attr("aria-label", "Powered by Shopify, this link open in a new tab");






jQuery(document).ready(function () {
    setTimeout(function () {
     jQuery(".globo-form-control textarea, .g-recaptcha-response").attr("aria-label", "message here");
        // jQuery("img[src='//cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/AjaxLoader.gif']").attr("alt", "loader");
      
jQuery(".card__heading a").removeAttr("aria-labelledby");
jQuery("label[for='34772-text-9'], label[for='34768-text-7'], label[for='34768-text-15'], label[for='34768-text-22']").attr("aria-label", "address field 2");
jQuery("label[for='34772-text-9'], label[for='34768-text-7'], label[for='34768-text-15'], label[for='34768-text-22']").attr("aria-hidden", "true");

        jQuery('.title.globo-heading').each(function() {
            const $this = jQuery(this);
            if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
                $this.remove();
        });

        $(".jdgm-widget-actions-wrapper a").removeAttr("href");
$(".jdgm-widget-actions-wrapper a").attr("role", "button");
$("h3.heading-title.globo-heading").attr("aria-level", "2");

    }, 2000);
    }, 2000);


    $( document ).ready(function() {
      //wait until the last element (#checkout-step-shipping_method) being rendered
      var existCondition = setInterval(function() {
       if ($('.text-danger').length) { 
        clearInterval(existCondition);
        runMyFunction2();
       }
      }, 200);
    
      function runMyFunction2(){
       console.log("Customer Email Laoding");
    $('.text-danger').attr('aria-hidden', 'true');
      }
        });
        
        $( document ).ready(function() {
          //wait until the last element (to add alt text) being rendered
var existCondition = setInterval(function() {
  if ($("img[src='//cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/AjaxLoader.gif']").length) {
  clearInterval(existCondition);
  runMyFunction2();
  }
  }, 200);
  function runMyFunction2(){
  console.log("Customer Email Laoding");
  $("img[src='//cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/AjaxLoader.gif']").attr("alt", "loader");
  }
            });



            $( document ).ready(function() {
              //wait until the last element (to add alt text) being rendered
    var existCondition = setInterval(function() {
      if ($("ul.mm-submenu.link-list.mm-last-level").length) {
      clearInterval(existCondition);
      runMyFunction2();
      }
      }, 200);
      function runMyFunction2(){
      console.log("Mens Tops");
      $('a[href="/collections/mens-tops"]').attr("aria-label", "Mens Tops");
      }
                });


                $( document ).ready(function() {
                  //wait until the last element (to add alt text) being rendered
        var existCondition = setInterval(function() {
          if ($("ul.mm-submenu.link-list.mm-last-level").length) {
          clearInterval(existCondition);
          runMyFunction2();
          }
          }, 200);
          function runMyFunction2(){
          console.log("Mens Bottoms");
          $('a[href="/collections/mens-bottoms"]').attr("aria-label", "Mens Bottoms");
          }
       });

       $( document ).ready(function() {
        //wait until the last element (#checkout-step-shipping_method) being rendered
        var existCondition = setInterval(function() {
         if ($('.jdgm-widget-actions-wrapper a').length) { 
          clearInterval(existCondition);
          runMyFunction2();
         }
        }, 200);
    
        function runMyFunction2(){
         console.log("adding for tab index value");
         $('.jdgm-widget-actions-wrapper a').attr('tabindex','0');
        }
      });

      $( document ).ready(function() {
        //checkbox on single product "You might also like"
        var existCondition = setInterval(function() {
         if ($('.lb-spc-details-checkbox-cont input').length) { 
          clearInterval(existCondition);
          runMyFunction2();
         }
        }, 200);
    
        function runMyFunction2(){
         console.log("Checkbox aria-label");
         $('.lb-spc-details-checkbox-cont input').attr('aria-label','Checkbox for');
        }
      });

      // Accessible Name issue

      $( document ).ready(function() {
        //wait until the last element (to add alt text) being rendered
      var existCondition = setInterval(function() {
      if ($("ul.mm-submenu.link-list.mm-last-level").length) {
      clearInterval(existCondition);
      runMyFunction2();
      }
      }, 200);
      function runMyFunction2(){
      console.log("Mens Tops");
      $('a[href="/collections/mens-baselayer"]').attr("aria-label", "Mens Base Layer");
      }
          });

    
          $( document ).ready(function() {
            //aria-label men submenu items
          var existCondition = setInterval(function() {
          if ($("ul.mm-submenu.link-list.mm-last-level").length) {
          clearInterval(existCondition);
          runMyFunction2();
          }
          }, 200);
          function runMyFunction2(){
          console.log("Mens");
          $('a[href="/collections/mens-boots"]').attr("aria-label", "Mens Boots");
          }
              });


          $( document ).ready(function() {
            //aria-label men submenu items
          var existCondition = setInterval(function() {
          if ($("#form-iframe-13131").length) {
          clearInterval(existCondition);
          runMyFunction2();
          }
          }, 200);
          function runMyFunction2(){
          console.log("Contact Form");
          $('#form-iframe-13131').attr('title','Contact Form')
          }
              });

              $( document ).ready(function() {
            //aria-label men submenu items
          var existCondition = setInterval(function() {
          if ($("#form-iframe-13132").length) {
          clearInterval(existCondition);
          runMyFunction2();
          }
          }, 200);
          function runMyFunction2(){
          console.log("Contact Form");
          $('#form-iframe-13132').attr('title','Donation Form')
          }
              });

               
            $( document ).ready(function() {
            //aria-label men submenu items
          var existCondition = setInterval(function() {
          if ($("form-iframe-13185").length) {
          clearInterval(existCondition);
          runMyFunction2();
          }
          }, 200);
          function runMyFunction2(){
          console.log("Job Form");
          $('form-iframe-13185').attr('title','Job Form')
          }
              });

            $('.parent-display fieldset.facets-wrap.parent-wrap.facets-wrap-vertical ul.no-js-list.list-unstyled.no-js li.list-menu__item.facets__item label.facet-checkbox input').attr('aria-label','test');
            $(document).ready(function() {
              $('a[href="/collections/mens-shoes"]').attr('aria-label', 'Shoes for Mens');
          });
          $('.circle-divider time').prepend('<span class="visually-hidden”>published on</span>');
          
          $(document).ready(function() {
            $('a.tes').attr("aria-label","http://www.allaboutcookies.org ,this link open in new window");
            $('a.policy').attr("aria-label","https://www.google.com/intl/en/policies/privacy/ ,this link open in new window");
            $('a.shopify').attr("aria-label","https://www.shopify.com/legal/privacy ,this link open in new window");
            $('a.tg').attr("aria-label","https://tools.google.com/dlpage/gaoptout ,this link open in new window");
            $('a.nu').attr("aria-label","http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work ,this link open in new window");
            $('a.fb').attr("aria-label","https://www.facebook.com/settings/?tab=ads ,this link open in new window");
            $('a.fb').attr("aria-label","https://www.facebook.com/settings/?tab=ads ,this link open in new window");
            $('a.google').attr("aria-label","https://www.google.com/settings/ads/anonymous ,this link open in new window");
            $('a.bin').attr("aria-label","https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ad ,this link open in new window");
            $('a.opt').attr("aria-label","http://optout.aboutads.info/ ,this link open in new window");
            $('a.mails').attr("aria-label","cs@appalachianoutfitters.com ,this link open in new window");
            $('a.mail').attr("aria-label","Email: cs@appalachianoutfitters.com");
            $('a.tel').attr("aria-label","phone number,Phone number: 330-655-5444");
          });
         